<div class= "page page--email-campaings">
  <div class="page__container">
    <h1 class="page__title  h2" translate>email_settings_list_title</h1>
    <div class="my-5">
    <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
      <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>common_list_tab_all</button>
      <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
        <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
          email_list_tab
        </button>
        <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
          pages_list_tab_active
        </button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device custom" [(activeId)]="activeId">
      <li [ngbNavItem]="1">
        <a ngbNavLink translate>email_list_tab</a>
        <ng-template ngbNavContent>
          <wsb-email-campaigns-tab-list></wsb-email-campaigns-tab-list>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink translate>email_dns_tab</a>
        <ng-template ngbNavContent>
          <wsb-email-campaigns-tab-dns></wsb-email-campaigns-tab-dns>
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
</div>
